import { forwardRef, type Ref, type SVGProps } from "react";

function SvbClipboardScoreHealthyColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_100_6586)">
        <path
          d="M22.46 3.59961C25.5198 0.539951 30.4802 0.539951 33.54 3.59961L34.2031 4.2627C36.0475 6.1069 38.549 7.14248 41.1572 7.14258H41.3262C45.6535 7.14258 49.1621 10.6512 49.1621 14.9785V15.1475C49.1622 17.7557 50.1978 20.2572 52.042 22.1016L52.7051 22.7646C55.7647 25.8245 55.7647 30.7849 52.7051 33.8447L52.042 34.5078C50.1978 36.3522 49.1622 38.8537 49.1621 41.4619V41.6309C49.1621 45.9582 45.6535 49.4668 41.3262 49.4668H41.1572C38.549 49.4669 36.0475 50.5025 34.2031 52.3467L33.54 53.0098C30.4802 56.0694 25.5198 56.0694 22.46 53.0098L21.7969 52.3467C19.9525 50.5025 17.451 49.4669 14.8428 49.4668H14.6738C10.3465 49.4668 6.83789 45.9582 6.83789 41.6309V41.4619C6.83779 38.8537 5.80221 36.3522 3.95801 34.5078L3.29492 33.8447C0.235265 30.7849 0.235263 25.8245 3.29492 22.7646L3.95801 22.1016C5.80221 20.2572 6.83779 17.7557 6.83789 15.1475V14.9785C6.83789 10.6512 10.3465 7.14258 14.6738 7.14258H14.8428C17.451 7.14248 19.9525 6.1069 21.7969 4.2627L22.46 3.59961Z"
          fill="url(#paint0_linear_100_6586)"
          stroke="#9ED79D"
          strokeWidth="2"
        />
        <path
          d="M15.1736 23.1568L27.3149 16.4786C27.5246 16.3632 27.7601 16.3027 27.9995 16.3027C28.2389 16.3027 28.4744 16.3632 28.6841 16.4786L40.8254 23.1568C40.9995 23.2525 41.1515 23.3836 41.2717 23.5417C41.3919 23.6997 41.4777 23.8813 41.5234 24.0746C41.5691 24.2678 41.5738 24.4685 41.5371 24.6637C41.5004 24.8589 41.4232 25.0442 41.3105 25.2077L29.1684 42.8122C29.0378 43.0014 28.8632 43.1561 28.6596 43.263C28.456 43.3699 28.2294 43.4257 27.9995 43.4257C27.7696 43.4257 27.543 43.3699 27.3394 43.263C27.1358 43.1561 26.9612 43.0014 26.8306 42.8122L14.6885 25.2084C14.5758 25.0449 14.4986 24.8596 14.4619 24.6644C14.4253 24.4692 14.4299 24.2685 14.4756 24.0753C14.5213 23.882 14.6071 23.7005 14.7273 23.5424C14.8475 23.3843 14.9995 23.2532 15.1736 23.1575V23.1568Z"
          fill="url(#paint1_linear_100_6586)"
        />
        <g filter="url(#filter0_f_100_6586)">
          <path
            d="M126.286 35.5685L137.102 44.8877L75.4567 98.2529L64.6409 88.9338L126.286 35.5685Z"
            fill="#E8F9E1"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_100_6586"
          x="52.6406"
          y="23.5684"
          width="96.4609"
          height="86.6836"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_100_6586" />
        </filter>
        <linearGradient
          id="paint0_linear_100_6586"
          x1="15.4"
          y1="0.304688"
          x2="28"
          y2="56.3047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_6586"
          x1="18.9582"
          y1="19.6931"
          x2="27.9989"
          y2="43.4259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
        <clipPath id="clip0_100_6586">
          <rect width="56" height="56" fill="white" transform="translate(0 0.304688)" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvbClipboardScoreHealthyColored);
export default ForwardRef;
